/* eslint-disable no-console */
/**
 * Liquidation announcement strip
 * - Dismiss button via localStorage.
 * - Disabled inside Shopify's theme editor so designers can re-toggle.
 *
 * Removed: live countdown ticker (artificial urgency).
 */
(function () {
  if (typeof document === 'undefined') return;

  function inEditor() {
    return !!(window.Shopify && (window.Shopify.designMode || window.Shopify.themeEditor));
  }

  function initDismiss() {
    if (inEditor()) return;

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-close]');
      if (!btn) return;
      var strip = btn.closest('.announcement-liquidation');
      if (!strip) return;
      var key = strip.getAttribute('data-storage-key') || 'liqstrip_dismissed_v1';
      try { window.localStorage.setItem(key, '1'); } catch (_) {}
      strip.classList.add('is-hidden');
      document.documentElement.style.removeProperty('--liq-strip-h');
    });

    document.querySelectorAll('.announcement-liquidation[data-dismissable="true"]').forEach(function (strip) {
      var key = strip.getAttribute('data-storage-key') || 'liqstrip_dismissed_v1';
      try {
        if (window.localStorage.getItem(key) === '1') {
          strip.classList.add('is-hidden');
        }
      } catch (_) {}
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDismiss);
  } else {
    initDismiss();
  }
})();
